import { isEmpty, isNil } from 'lodash';
import moment, { Moment } from 'moment';

import type { PersonForm } from '@appTypes/common/types';
import { omitNullish } from '@shared/utils/omitHelpers';

import { dtoDateFormat, dtoDateTimeFormat } from '../constants';

type AdditionalInfoProfile = {
  swimmingClassification?: string;
  swimmingClassificationDate?: string;
  annualHealthRecordABDate?: string;
  annualHealthRecordCDate?: string;
  talentReleaseUserId?: number;
  talentReleaseDate?: string;
  talentReleaseDateRaw?: string | null;
};

const formatDate = (date?: Moment | null, format?: string) => {
  if (date === undefined) return undefined;
  return date ? date.format(format) : undefined;
};

const resolveTalentReleaseDate = (
  talentRelease: boolean | null | undefined,
  format: string,
) => {
  if (talentRelease === undefined) return undefined;
  return talentRelease ? moment().format(format) : undefined;
};

export default function formatAdditionalInfoProfile(
  profile: Partial<PersonForm>,
  userId: number,
): AdditionalInfoProfile {
  const {
    talentRelease,
    swimmingClassification,
    swimmingClassificationDate,
    annualHealthRecordABDate,
    annualHealthRecordCDate,
  } = profile;

  const result: AdditionalInfoProfile = {
    talentReleaseUserId: talentRelease === undefined ? undefined : userId,

    talentReleaseDate: resolveTalentReleaseDate(talentRelease, dtoDateFormat),

    talentReleaseDateRaw: resolveTalentReleaseDate(
      talentRelease,
      dtoDateTimeFormat,
    ),

    annualHealthRecordABDate: formatDate(
      annualHealthRecordABDate,
      dtoDateFormat,
    ),

    annualHealthRecordCDate: formatDate(annualHealthRecordCDate, dtoDateFormat),
  };

  if (!isNil(swimmingClassification) && !isEmpty(swimmingClassification)) {
    result.swimmingClassification = swimmingClassification;
    result.swimmingClassificationDate = formatDate(
      swimmingClassificationDate,
      dtoDateFormat,
    );
  }

  return omitNullish(result);
}
